import { render, staticRenderFns } from "./PublishingContractsReadOnly.vue?vue&type=template&id=67b4b714"
import script from "./PublishingContractsReadOnly.vue?vue&type=script&lang=js"
export * from "./PublishingContractsReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports